import { Component } from 'react';
import PageMeta from './PageMeta';
import { Link } from 'react-router-dom';
import SakuraSep from './SakuraSep';
import BurstBtn from './BurstBtn';
import Reveal from './Reveal';
import { DataRPC } from '../../rpc-client/DataRPC';
import { s3 } from '../../config/constants';
import { drawFortune, EL_META, INTERACTION_META } from './fortune';

const rpc = new DataRPC();

const walls = ['wall1.jpg', 'wall2.jpg', 'wall3.jpg'];

const WISH_DIRS = [
    { x: 0, y: -1 }, { x: 0.71, y: -0.71 }, { x: 1, y: 0 }, { x: 0.71, y: 0.71 },
    { x: 0, y: 1 }, { x: -0.71, y: 0.71 }, { x: -1, y: 0 }, { x: -0.71, y: -0.71 },
];

const fmtDate = d => {
    if (!d) return '';
    const dt = new Date(d);
    return `${dt.getFullYear()}/${String(dt.getMonth() + 1).padStart(2, '0')}/${String(dt.getDate()).padStart(2, '0')}`;
};

/* ── Sponsor data ─────────────────────────────────────────── */
const SPONSORS = [
    { name: 'VietJet Air',  logo: 'images/logo/samsung.png' },
    { name: 'Honda',        logo: 'images/logo/honda.png' },
    { name: 'VietJet Air',  logo: 'images/logo/nuitruc.png' },
    { name: 'Honda',        logo: 'images/logo/honda.png' },
    { name: 'VietJet Air',  logo: 'images/logo/samsung.png' },
 { name: 'VietJet Air',  logo: 'images/logo/nuitruc.png' },
    { name: 'VietJet Air',  logo: 'images/logo/samsung.png' },
    { name: 'Honda',        logo: 'images/logo/honda.png' },
 { name: 'VietJet Air',  logo: 'images/logo/nuitruc.png' },
    { name: 'Honda',        logo: 'images/logo/honda.png' },
    { name: 'VietJet Air',  logo: 'images/logo/samsung.png' },
 { name: 'VietJet Air',  logo: 'images/logo/nuitruc.png' },
];

class Home extends Component {
    state = {
        curr: 0,
        imgs: [0, 1],
        teams: [],
        teamsLoading: true,
        feedbacks: [],
        feedbacksLoading: true,
        products: [],
        productsLoading: true,
        hotNews: null,
        newsList: [],
        newsLoading: true,
        sponsors: [],
        albums: [],
        albumsLoading: true,
        hoveredTeam: null,
        tooltipStyle: {},
        spinning: false,
        fortuneTeam: null,
        showFortune: false,
        fortuneLastUsed: null,
        cooldownFlash: null,
        wishHoldActive:   false,
        wishHoldProgress: 0,
        wishBurst:        false,
    };

    _holdRaf   = null;
    _holdStart = null;

    componentDidMount() {
        rpc.fetchRawData('GetTeams', { page: 1, limit: 16, location: 'vn', random: true })
            .then(res => this.setState({ teams: res.data || [], teamsLoading: false }))
            .catch(() => this.setState({ teamsLoading: false }));

        rpc.fetchRawData('GetFeedback', { page: 1, limit: 4 })
            .then(res => this.setState({ feedbacks: res.data || [], feedbacksLoading: false }))
            .catch(() => this.setState({ feedbacksLoading: false }));

        rpc.fetchRawData('GetProducts', { page: 1, limit: 6 })
            .then(res => this.setState({ products: res.data || [], productsLoading: false }))
            .catch(() => this.setState({ productsLoading: false }));

        rpc.fetchRawData('GetHomeNews', {})
            .then(res => this.setState({ hotNews: res.hot || null, newsList: res.list || [], newsLoading: false }))
            .catch(() => this.setState({ newsLoading: false }));

        rpc.fetchRawData('GetSponsors', { page: 1, limit: 50 })
            .then(res => this.setState({ sponsors: res.data || [] }))
            .catch(() => {});

        rpc.fetchRawData('GetAlbums', { page: 1, limit: 8, status: 'done' })
            .then(res => this.setState({ albums: res.data || [], albumsLoading: false }))
            .catch(() => this.setState({ albumsLoading: false }));

        this.slideInterval = setInterval(() => {
            this.setState(prev => {
                const nextLayer = prev.curr === 0 ? 1 : 0;
                const nextImgIdx = (prev.imgs[prev.curr] + 1) % walls.length;
                const imgs = [...prev.imgs];
                imgs[nextLayer] = nextImgIdx;
                return { curr: nextLayer, imgs };
            });
        }, 4500);

        const $ = window.jQuery;
        if (!$) return;


    }

    componentWillUnmount() {
        clearInterval(this.slideInterval);
        if (this._holdRaf) cancelAnimationFrame(this._holdRaf);
    }

    startWishHold = (e) => {
        e.preventDefault();
        this._holdStart = performance.now();
        this.setState({ wishHoldActive: true, wishHoldProgress: 0, wishBurst: false });
        this._animateHold();
    };

    _animateHold = () => {
        const elapsed  = performance.now() - this._holdStart;
        const progress = Math.min(elapsed / 1500, 1);
        this.setState({ wishHoldProgress: progress });
        if (progress < 1) {
            this._holdRaf = requestAnimationFrame(this._animateHold);
        } else {
            this._holdRaf = null;
            this.setState({ wishBurst: true, wishHoldActive: false });
            setTimeout(() => this.props.history.push('/ema', { allowed: true }), 900);
        }
    };

    cancelWishHold = () => {
        if (this._holdRaf) { cancelAnimationFrame(this._holdRaf); this._holdRaf = null; }
        if (!this.state.wishBurst) {
            this.setState({ wishHoldActive: false, wishHoldProgress: 0 });
        }
    };

    handleFortune = () => {
        const { spinning, teams, fortuneLastUsed } = this.state;
        if (spinning || !teams.length) return;

        if (fortuneLastUsed) {
            const remaining = 3600000 * 60 * 1000 - (Date.now() - fortuneLastUsed);  // set cooldown for fortune-telling, replace 0
            if (remaining > 0) {
                const minsLeft = Math.ceil(remaining / 60000);
                this.setState({ cooldownFlash: minsLeft });
                clearTimeout(this._cooldownTimer);
                this._cooldownTimer = setTimeout(() => this.setState({ cooldownFlash: null }), 3500);
                return;
            }
        }

        this.setState({ spinning: true, showFortune: false, fortuneTeam: null, cooldownFlash: null });
        setTimeout(() => {
            const picked = teams[Math.floor(Math.random() * teams.length)];
            const drawn = drawFortune(picked);
            this.setState({ spinning: false, fortuneTeam: { ...picked, ...drawn }, showFortune: true, fortuneLastUsed: Date.now() });
        }, 2600);
    };

    handleOrbitHover = (e, team) => {
        const rect = e.currentTarget.getBoundingClientRect();
        this.setState({
            hoveredTeam: team,
            tooltipStyle: { left: rect.left + rect.width / 2, top: rect.bottom + 10 },
        });
    };

    handleOrbitLeave = () => {
        this.setState({ hoveredTeam: null, tooltipStyle: {} });
    };

    render() {
        const { curr, imgs, teams, teamsLoading, feedbacks, feedbacksLoading, products, productsLoading, hotNews, newsList, newsLoading, sponsors, hoveredTeam, tooltipStyle, spinning, fortuneTeam, showFortune, wishHoldActive, wishHoldProgress, wishBurst } = this.state;
        const sponsorBase = sponsors.length
            ? sponsors.map(sp => ({ ...sp, logo: s3(sp.logo, '') }))
            : SPONSORS;
        const repeat = Math.ceil(16 / sponsorBase.length);
        const sponsorList = Array.from({ length: repeat }, () => sponsorBase).flat();
        const innerTeams = teams.slice(0, 8);
        const outerTeams = teams.slice(8, 16);
        return (
            <>
                <PageMeta title="Trang chủ" description="Vietnam Yosakoi Festival – Lễ hội nhảy Yosakoi tại Việt Nam. Khám phá lịch biểu diễn, các đội và album ảnh." url="/" />
                {/* Hero */}
                <div className="hero-content">
                    <div className="hero-slide" style={{ backgroundImage: `url(images/wall/${walls[imgs[0]]})`, opacity: curr === 0 ? 1 : 0 }} />
                    <div className="hero-slide" style={{ backgroundImage: `url(images/wall/${walls[imgs[1]]})`, opacity: curr === 1 ? 1 : 0 }} />
                    <div className="hero-overlay" />
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-lg-8 offset-lg-2">
                                <div className="entry-header">
                                    <h2 className="hero-title-img-wrap">
                                        <img src="images/hero-title.png" alt="Việt Nam Yosakoi Festival" className="hero-title-img" />
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="sep-gold-rule" style={{margin: 0}} />

                {/* News Block */}
                <Reveal as="div" className="homepage-news-block">
                    {/* Sponsors */}
                    <div className="spn-section">
                        <div className="spn-marquee-wrap">
                            <div className="spn-marquee-track">
                                {[...sponsorList, ...sponsorList].map((sp, i) => (
                                    <span key={i} className="spn-marquee-item">
                                        <img src={sp.logo} alt={sp.name} className="spn-logo-img" />
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        {(newsLoading || hotNews || newsList.length > 0) && (
                        <div className="hnb-header">
                            <div className="entry-title">
                                <p>TIN TỨC</p>
                                <h2>THÔNG TIN MỚI NHẤT VỀ YOSAKOI VIỆT NAM</h2>
                            </div>
                        </div>
                        )}

                        {/* Featured newest news */}
                        {hotNews && (
                        <div className="news-featured">
                            <div className="row align-items-center">
                                <div className="col-12 col-md-6">
                                    <figure className="news-featured-image">
                                        <Link to={`/news/${hotNews.slug || hotNews.id}`}><img src={s3(hotNews.avatar_url, 'images/news-image-1.jpg')} alt={hotNews.title} /></Link>
                                    </figure>
                                </div>
                                <div className="col-12 col-md-6">
                                    <div className="news-featured-body">
                                        <div className="news-meta">
                                            <span className="news-date">{fmtDate(hotNews.published_at || hotNews.created_at)}</span>
                                        </div>
                                        <h3 className="news-featured-title">
                                            <Link to={`/news/${hotNews.slug || hotNews.id}`}>{hotNews.title}</Link>
                                        </h3>
                                        <p className="news-featured-excerpt">{hotNews.short_description}</p>
                                        <Link to={`/news/${hotNews.slug || hotNews.id}`} className="news-read-more">Đọc thêm <span>→</span></Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        )}

                        {/* News list */}
                        {!newsLoading && newsList.length > 0 && (
                        <div className="news-list">
                            {newsList.map(item => (
                                <div key={item.id} className="news-list-item">
                                    <span className="nli-date">{fmtDate(item.published_at || item.created_at)}</span>
                                    <Link to={`/news/${item.slug || item.id}`} className="nli-title">{item.title}</Link>
                                </div>
                            ))}
                        </div>
                        )}

                        {(newsLoading || hotNews || newsList.length > 0) && (
                        <div className="news-view-all">
                            <BurstBtn to="/news" className="btn btn-img-base btn-img-down">XEM TẤT CẢ TIN TỨC</BurstBtn>
                        </div>
                        )}
                    </div>

                    {(newsLoading || hotNews || newsList.length > 0) && <SakuraSep />}
                </Reveal>

                {/* Content */}
                <div className="content-section">
                    <div className="container">
                        {/* Lineup headliners */}
                        <Reveal as="div" className="row" id="lineup">
                            <div className="col-12">
                                <div className="lineup-artists-headline">
                                    {(feedbacksLoading || feedbacks.length > 0) && (
                                    <>
                                    <div className="entry-title">
                                        <p>JUST THE BEST</p>
                                        <h2>NHỮNG NGƯỜI XÂY DỰNG LỄ HỘI VIỆT</h2>
                                    </div>

                                    <div className="row lineup-artists">
                                        {feedbacksLoading
                                            ? [...Array(4)].map((_, i) => (
                                                <div key={i} className="col-12 col-md-6 col-lg-3 headliner-col">
                                                    <div className="headliner-card headliner-card-skeleton" />
                                                </div>
                                            ))
                                            : feedbacks.map((fb, i) => (
                                                <div key={fb.id} className="col-12 col-md-6 col-lg-3 headliner-col">
                                                    <div className="headliner-card">
                                                        <img src={s3(fb.images, 'images/black-chick.jpg')} alt={fb.name} />
                                                        <span className="headliner-num">0{i + 1}</span>
                                                        <div className="headliner-info">
                                                            <span className="headliner-quote-mark">"</span>
                                                            <p className="headliner-quote">{fb.feedback || ''}</p>
                                                            <h3>{fb.name}</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                    </div>
                                    </>
                                    )}
                                </div>
                            </div>
                        </Reveal>

                        {(feedbacksLoading || feedbacks.length > 0) && <SakuraSep />}

                        {/* Complete lineup grid */}
                        <div className="row">
                            <div className="col-12">
                                <div className="the-complete-lineup">
                                    <div className="entry-title">
                                        <p>JUST THE BEST</p>
                                        <h2>VIỆT NAM YOSAKOI TEAM</h2>
                                    </div>

                                    <div className="lineup-orbit-wrap">
                                        {/* Left side floating deco */}
                                        <div className="orbit-side orbit-side-left">
                                            <div className="orbit-float-bubble ofl-a">
                                                <span className="ofl-kanji">踊</span>
                                                <span className="ofl-label">YOSAKOI</span>
                                            </div>
                                            <div className="orbit-float-bubble ofl-b">
                                                <span className="ofl-num">16+</span>
                                                <span className="ofl-label">ĐỘI</span>
                                            </div>
                                            <div className="orbit-float-bubble ofl-c">
                                                <span className="ofl-kanji">花</span>
                                                <span className="ofl-label">SAKURA</span>
                                            </div>
                                        </div>

                                        {/* Right side floating deco */}
                                        <div className="orbit-side orbit-side-right">
                                            <div
                                                className={`orbit-float-bubble ofl-b wishes-btn${wishHoldActive ? ' wishes-holding' : ''}${wishBurst ? ' wishes-burst' : ''}`}
                                                onPointerDown={this.startWishHold}
                                                onPointerUp={this.cancelWishHold}
                                                onPointerLeave={this.cancelWishHold}
                                                onPointerCancel={this.cancelWishHold}
                                            >
                                                <span className="ofl-kanji">願い</span>
                                                <span className="ofl-label">WISHES</span>
                                                {wishHoldActive && (
                                                    <svg className="wishes-ring" viewBox="0 0 44 44">
                                                        <circle cx="22" cy="22" r="20" className="wishes-ring-bg" />
                                                        <circle cx="22" cy="22" r="20" className="wishes-ring-fill"
                                                            style={{ strokeDashoffset: 125.7 * (1 - wishHoldProgress) }} />
                                                    </svg>
                                                )}
                                                {wishBurst && WISH_DIRS.map((d, i) => (
                                                    <span key={i} className="wishes-petal"
                                                        style={{ '--tx': `${d.x * 80}px`, '--ty': `${d.y * 80}px`, animationDelay: `${i * 0.05}s` }}>
                                                        🌸
                                                    </span>
                                                ))}
                                            </div>
                                            <div className="orbit-float-bubble ofl-c">
                                                <span className="ofl-num">2026</span>
                                                <span className="ofl-label">FESTIVAL</span>
                                            </div>
                                            <div className="orbit-float-bubble ofl-a">
                                                <span className="ofl-kanji">祭</span>
                                                <span className="ofl-label">MATSURI</span>
                                            </div>
                                        </div>

                                        <div
                                            className={`lineup-orbit-center${spinning ? ' orbit-center-spinning' : ''}`}
                                            onClick={this.handleFortune}
                                            title="Bấm vào làm tí!"
                                        >
                                            <div className="lineup-orbit-core">
                                                {spinning
                                                    ? <><span className="lineup-orbit-kanji">運</span><p className="lineup-orbit-count">Số mệnh hôm nay của bạn</p></>
                                                    : this.state.cooldownFlash
                                                    ? <><span className="lineup-orbit-kanji fortune-cooldown-kanji">待</span><p className="lineup-orbit-count">Thiên mệnh đang hồi chiêu, xin thử lại sau</p></>
                                                    : <><span className="lineup-orbit-kanji">祭</span><p className="lineup-orbit-count fortune-hint">✦ 運命がここに ✦</p></>
                                                }
                                            </div>
                                        </div>

                                        {/* Inner ring — up to 8 teams, clockwise */}
                                        <div className={`lineup-orbit-inner${spinning ? ' orbit-ring-fast' : ''}`}>
                                            {teamsLoading
                                                ? [...Array(8)].map((_, i) => (
                                                    <div key={i} className={`orbit-item orbit-item-${i + 1}`}>
                                                        <figure className="artist-card artist-card-skeleton" />
                                                    </div>
                                                ))
                                                : innerTeams.map((team, i) => (
                                                    <div key={team.id} className={`orbit-item orbit-item-${i + 1}`}>
                                                        <figure className="artist-card">
                                                            <Link
                                                                to={{ pathname: `/teams/${team.slug || team.id}`, state: { team } }}
                                                                className="artist-scale-wrap"
                                                                onMouseEnter={e => this.handleOrbitHover(e, team)}
                                                                onMouseLeave={this.handleOrbitLeave}
                                                                onTouchStart={e => this.handleOrbitHover(e, team)}
                                                                onTouchEnd={this.handleOrbitLeave}
                                                            >
                                                                <img src={s3(team.avatar_url, 'images/team/team1.jpg')} alt={team.name} />
                                                            </Link>
                                                        </figure>
                                                    </div>
                                                ))
                                            }
                                        </div>

                                        {/* Outer ring — up to 8 teams, counter-clockwise */}
                                        <div className={`lineup-orbit-outer${spinning ? ' orbit-ring-fast' : ''}`}>
                                            {teamsLoading
                                                ? [...Array(8)].map((_, i) => (
                                                    <div key={i} className={`orbit-item orbit-item-${i + 1}`}>
                                                        <figure className="artist-card artist-card-skeleton" />
                                                    </div>
                                                ))
                                                : outerTeams.map((team, i) => (
                                                    <div key={team.id} className={`orbit-item orbit-item-${i + 1}`}>
                                                        <figure className="artist-card">
                                                            <Link
                                                                to={{ pathname: `/teams/${team.slug || team.id}`, state: { team } }}
                                                                className="artist-scale-wrap"
                                                                onMouseEnter={e => this.handleOrbitHover(e, team)}
                                                                onMouseLeave={this.handleOrbitLeave}
                                                                onTouchStart={e => this.handleOrbitHover(e, team)}
                                                                onTouchEnd={this.handleOrbitLeave}
                                                            >
                                                                <img src={s3(team.avatar_url, 'images/team/team9.jpg')} alt={team.name} />
                                                            </Link>
                                                        </figure>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>

                                    <div className="row justify-content-center">
                                        <div className="see-complete-lineup">
                                            <div className="entry-footer">
                                                <BurstBtn to="/teams" className="btn btn-img-base btn-img-down">XEM TOÀN BỘ TEAM</BurstBtn>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <SakuraSep />

                    {/* Newest Albums slider */}
                    <Reveal as="div" className="homepage-next-events">
                        <div className="container">
                            <div className="row">
                                <div className="col-12">
                                    <div className="entry-title">
                                        <p>JUST THE BEST</p>
                                        <h2>ALBUM ẢNH MỚI NHẤT</h2>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="next-event-slider-wrap">
                            <div className="alb-marquee-wrap">
                                <div className="alb-marquee-track">
                                    {(() => {
                                        const base = this.state.albums.length > 0
                                            ? Array.from({ length: Math.max(6, this.state.albums.length) }, (_, i) => this.state.albums[i % this.state.albums.length])
                                            : [];
                                        return [...base, ...base].map((a, i) => (
                                            <div key={i} className="alb-marquee-item">
                                                <Link to={`/gallery/album/${a.id}`} className="hm-album-card">
                                                    <div className="hm-album-img-wrap">
                                                        <img src={s3(a.cover_image_url, 'images/next-event-1.jpg')} alt={a.title} />
                                                        <div className="hm-album-overlay" />
                                                        {a.pic_number > 0 && (
                                                            <span className="hm-album-badge">
                                                                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                                    <circle cx="12" cy="13" r="4" stroke="currentColor" strokeWidth="2"/>
                                                                </svg>
                                                                {a.pic_number}
                                                            </span>
                                                        )}
                                                    </div>
                                                    <div className="hm-album-body">
                                                        <h3 className="hm-album-title">{a.title}</h3>
                                                        <div className="hm-album-rows">
                                                            <div className="hm-album-row">
                                                                <span className="hm-album-key">Ngày chụp</span>
                                                                <span className="hm-album-val">{fmtDate(a.created_at)}</span>
                                                            </div>
                                                            {a.festival_name && (
                                                                <div className="hm-album-row">
                                                                    <span className="hm-album-key">Sự kiện</span>
                                                                    <span className="hm-album-val">{a.festival_name}</span>
                                                                </div>
                                                            )}
                                                            {a.cameraman_name && (
                                                                <div className="hm-album-row">
                                                                    <span className="hm-album-key">Nháy</span>
                                                                    <span className="hm-album-val hm-album-phot">{a.cameraman_name}</span>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <span className="hm-album-view">Xem Album →</span>
                                                    </div>
                                                </Link>
                                            </div>
                                        ));
                                    })()}
                                </div>
                            </div>
                        </div>
                        <div className="news-view-all">
                            <BurstBtn to="/gallery" className="btn btn-img-base btn-img-down">XEM TẤT CẢ ALBUM</BurstBtn>
                        </div>
                    </Reveal>

                    <SakuraSep />

                    {/* Products */}
                    <Reveal as="div" className="homepage-products">
                        <div className="container">
                            <div className="entry-title">
                                <p>CỬA HÀNG</p>
                                <h2>SẢN PHẨM LỄ HỘI</h2>
                            </div>

                            <div className="products-grid">
                                {productsLoading
                                    ? [...Array(6)].map((_, i) => (
                                        <div key={i} className="product-card product-card-skeleton" />
                                    ))
                                    : products.map(p => (
                                        <div key={p.id} className="product-card">
                                            <figure className="product-image">
                                                <img src={s3(p.avatar_url, 'images/ao.jpg')} alt={p.name} />
                                            </figure>
                                            {p.status === 'out_of_stock' && <span className="product-hot">HẾT HÀNG</span>}
                                            <div className="product-body">
                                                <h3 className="product-name">{p.name}</h3>
                                                <div className="product-price">{Number(p.price).toLocaleString('vi-VN')} ₫</div>
                                                <Link to="/products" className="btn-buy">Mua Ngay</Link>
                                            </div>
                                        </div>
                                    ))}
                            </div>

                            <div className="products-view-all">
                                <BurstBtn className="btn btn-img-base btn-img-down">TẤT CẢ SẢN PHẨM</BurstBtn>
                            </div>
                        </div>
                    </Reveal>

                    <SakuraSep />
                </div>

                <div className="sep-gold-rule" style={{margin: 0}} />

            {hoveredTeam && (
                    <div className="orbit-label-fixed" style={tooltipStyle}>
                       {hoveredTeam.name}
                    </div>
                )}

                {showFortune && fortuneTeam && (
                    <div className="fortune-overlay" onClick={() => this.setState({ showFortune: false, fortuneTeam: null })}>
                        <div className="fortune-card" onClick={e => e.stopPropagation()}>
                            <button className="fortune-close" onClick={() => this.setState({ showFortune: false, fortuneTeam: null })}>✕</button>
                            <div className="fortune-card-top">
                                <div className="fortune-avatar">
                                    <img src={s3(fortuneTeam.avatar_url, 'images/team/team1.jpg')} alt={fortuneTeam.name} />
                                </div>
                                <div className="fortune-team-info">
                                    <p className="fortune-team-label">TEAM CHIẾU MỆNH CỦA BẠN HÔM NAY</p>
                                    <h3 className="fortune-team-name">{fortuneTeam.name}</h3>
                                    {EL_META[fortuneTeam.teamEl] && (
                                        <span className="fortune-el-badge" style={{ background: EL_META[fortuneTeam.teamEl].bg, color: EL_META[fortuneTeam.teamEl].color }}>
                                            {EL_META[fortuneTeam.teamEl].label}
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="fortune-interaction-row">
                                <span className="fortune-day-el">{fortuneTeam.fortune.weekday} · ngày {fortuneTeam.fortune.dayLabel}</span>
                                {INTERACTION_META[fortuneTeam.interaction] && (
                                    <span className="fortune-interaction-badge" style={{ color: INTERACTION_META[fortuneTeam.interaction].color }}>
                                        {INTERACTION_META[fortuneTeam.interaction].label}
                                    </span>
                                )}
                            </div>
                            <div className="fortune-divider" />
                            <div className="fortune-body">
                                <span className="fortune-icon">{fortuneTeam.fortune.icon}</span>
                                <p className="fortune-title">{fortuneTeam.fortune.title}</p>
                                <p className={`fortune-stars${fortuneTeam.interaction === 'khac' ? ' fortune-stars--hard' : ''}`}>
                                    {fortuneTeam.interaction === 'khac' ? 'Độ khó' : 'Vận khí'}{' '}
                                    <span>{'★'.repeat(fortuneTeam.fortune.stars)}{'☆'.repeat(5 - fortuneTeam.fortune.stars)}</span>
                                </p>
                                <p className="fortune-msg">「 {fortuneTeam.fortune.msg} 」</p>

                                {fortuneTeam.fortune.quest && (
                                    <div className="fortune-quest">
                                        <p className="fortune-quest-label">🎯 THỬ THÁCH HÓA GIẢI</p>
                                        <p className="fortune-quest-text">{fortuneTeam.fortune.quest}</p>
                                        {fortuneTeam.fortune.reward && (
                                            <p className="fortune-quest-reward">🏅 Hoàn thành: {fortuneTeam.fortune.reward}</p>
                                        )}
                                    </div>
                                )}

                                <div className="fortune-lucky">
                                    <div><span>🍀 Vật may mắn</span><b>{fortuneTeam.fortune.lucky.item}</b></div>
                                    <div><span>🎨 Màu hợp</span><b>{fortuneTeam.fortune.lucky.color}</b></div>
                                    <div><span>🔢 Con số</span><b>{fortuneTeam.fortune.lucky.number}</b></div>
                                    <div><span>⏰ Giờ đẹp</span><b>{fortuneTeam.fortune.lucky.hour}</b></div>
                                    <div className="fortune-lucky-wide"><span>💃 Động tác hên</span><b>{fortuneTeam.fortune.lucky.move}</b></div>
                                </div>
                                <p className="fortune-taboo">🚫 Kiêng: {fortuneTeam.fortune.taboo}</p>
                            </div>
                            <button className="fortune-retry" onClick={() => this.setState({ showFortune: false, fortuneTeam: null })}>
                                ✕ Tiếp nhận thiên mệnh
                            </button>
                        </div>
                    </div>
                )}
            </>
        );
    }
}

export default Home;
